import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MaterialResource\UpdateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/UpdateMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
const UpdateMaterialResourceController = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateMaterialResourceController.url(args, options),
    method: 'put',
})

UpdateMaterialResourceController.definition = {
    methods: ["put"],
    url: '/api/material-resource/{material_resource}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\MaterialResource\UpdateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/UpdateMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
UpdateMaterialResourceController.url = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { material_resource: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { material_resource: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            material_resource: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return UpdateMaterialResourceController.definition.url
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\UpdateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/UpdateMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
UpdateMaterialResourceController.put = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateMaterialResourceController.url(args, options),
    method: 'put',
})

export default UpdateMaterialResourceController